import { BuildInfo } from "@um/contracts";
import { logException } from "../telemetry";

// Build metadata is immutable for the lifetime of the page, but several
// startup paths ask for it independently (telemetry tags, auto-update check,
// version display). Memoize the in-flight promise so a cold load issues one
// request instead of three.
let cached: Promise<BuildInfo | null> | null = null;

export function getBuildInfo(): Promise<BuildInfo | null> {
  if (!cached) cached = fetchBuildInfo();
  return cached;
}

async function fetchBuildInfo(): Promise<BuildInfo | null> {
  try {
    const response = await fetch("/git-commit-info.json");
    if (!response.ok) {
      logException(
        new Error(
          `Failed to fetch build metadata (likely in dev mode): status: ${response.status} - ${response.statusText}`
        )
      );
      return null;
    }
    const json = await response.json();
    return json as BuildInfo;
  } catch (err) {
    logException(err);
  }
  return null;
}
